// Hook genérico para cargar datos de reportes dash
import { useQuery } from '@tanstack/react-query'
import { fetchDashReport } from '../api/dash.api'

export function useDashReport<T = Record<string, unknown>>(endpoint: string) {
  return useQuery<T>({
    queryKey: ['dash', endpoint],
    queryFn: () => fetchDashReport<T>(endpoint),
    staleTime: 5 * 60 * 1000, // 5 minutos - datos estáticos
    retry: 2,
  })
}
